import { makeObservable, observable } from 'mobx'

export abstract class AbstractCatalogStore<C, I> {
  public configItemList: C[] = []
  public configItemDetails: C
  public itemList: I[] = []
  public itemListFilter: TObjectAny = {}
  public path: I[] = []
  public page = 1
  public total = 0
  public pageSize = 100
  public itemDetails: I
  public itemLoadingId: string | null = null

  protected constructor(params: ICatalogStoreParams<C, I>) {
    this.configItemDetails = params.createConfig({})
    this.itemDetails = params.createItem({})

    // makeAutoObservable does not work with subclasses
    makeObservable(this, {
      configItemList: observable,
      configItemDetails: observable,
      itemList: observable,
      itemListFilter: observable,
      path: observable,
      page: observable,
      total: observable,
      pageSize: observable,
      itemDetails: observable,
      itemLoadingId: observable,
    })
  }
}

export interface ICatalogStoreParams<C, I> {
  createConfig: (data: TObjectAny) => C
  createItem: (data: TObjectAny) => I
}
